import { createAction, props } from '@ngrx/store';

import { BaseNotificationBody, WebNotification } from '@shared/interfaces/notification.interface';

/**
 * Clear Notifications store
 */
export const clearNotificationsStore = createAction('[Notifications] Clear Notifications store');

/**
 * add latest notification
 */
export const addLatestNotification = createAction(
  '[Notifications] add latest Notification',
  props<{ notification: WebNotification }>()
);
/**
 * add latest notification of any user any event
 */
export const addLatestAnyNotification = createAction(
  '[Notifications] add latest any Notification',
  props<{ notification: WebNotification }>()
);
/**
 * mark last notification of any user any event
 */
export const markAnyNotificationsAsRead = createAction(
  '[Notifications] mark all turnovers of any notifications as read',
  props<{ turnoverId: number }>()
);
/**
 * clear list of any notification
 */
export const clearAnyNotifications = createAction('[Notifications] clear list of any notifications');
/**
 * clear list of any notification
 */
export const updateAnyNotifications = createAction(
  '[Notifications] update list of any notifications',
  props<{ list: WebNotification[] }>()
);

/**
 * get last notification list
 */
export const getLastNotificationList = createAction('[Notifications] get last notification list');
export const getLastNotificationListSuccess = createAction(
  '[Notifications] get last notification list success',
  props<{ lastNotificationList: WebNotification[] }>()
);
export const getLastNotificationListFailed = createAction('[Notifications] get last notification list failed');

/**
 * mark all as read
 */
export const markAllAsRead = createAction('[Notifications] set all as read');
export const markAllAsReadSuccess = createAction('[Notifications] set all as read success');
export const markAllAsReadFailed = createAction('[Notifications] set mark all as read failed');

/**
 * mark selected as read
 */
export const markAsRead = createAction(
  '[Notifications] set mark all as read',
  props<{ baseNotificationBody: BaseNotificationBody }>()
);
export const markAsReadSuccess = createAction('[Notifications] set mark all as read success');
export const markAsReadFailed = createAction('[Notifications] set mark all as read failed');

/**
 * delete notification
 */
export const deleteNotification = createAction(
  '[Notifications] delete notification',
  props<{ baseNotificationBody: BaseNotificationBody }>()
);
export const deleteNotificationSuccess = createAction('[Notifications] delete notification success');
export const deleteNotificationFailed = createAction('[Notifications] delete notification failed');
